import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import { AiOutlineHeart } from "react-icons/ai";
import { FiShoppingCart, FiUser } from "react-icons/fi";
import ConnexionModal from "./modal/ConnexionModal";
import SearchForm from "./SearchForm";
import { useAppDispatch, useAppSelector } from "../../../redux/hook";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { getTotalAmount } from "../../../redux/slice/useCartSlice";
import { useSearchParams, useLocation } from "react-router-dom";
import MobileCategoryModal from "../../user/ParcoursAchat/modal/MobileCategoryModal";
import { TfiMenuAlt } from "react-icons/tfi";

const KAZA_LOGO = `${process.env.PUBLIC_URL}/kazamansa_logo.png`;

const FrontHeader = () => {
  const dispatch = useAppDispatch();
  const { user, token } = useAppSelector((s) => s?.user);
  const { cartItems } = useAppSelector((state) => state.cart);
  const [modalConnexion, setModalConnexion] = useState(false);
  let [searchParams] = useSearchParams();
  const [searchCategory, setSearchCategory] = useState<any>();
  const [searchSousCategory, setSearchSousCategory] = useState<any>();
  const [query, setQuery] = React.useState({
    category: searchParams?.get("category") || "",
    min: searchParams?.get("min") || "",
    max: searchParams?.get("max") || "",
    orderBy: searchParams?.get("orderBy") || "",
  });

  const [value, setValue] = React.useState<any>({
    min: searchParams?.get("min") || 0,
    max: searchParams?.get("max") || 9000000,
  });
  let { state } = useLocation();

  useEffect(() => {
    dispatch(getTotalAmount());
  }, [cartItems]);

  const [showCategoryModal, setShowCategoryModal] = useState(false);

  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 12) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const openConnexion = () => setModalConnexion(true);

  const renderAccountLink = (className: string) =>
    !token ? (
      <button
        type="button"
        onClick={openConnexion}
        className={className}
      >
        <FiUser className="kazamansa-icon-accent" aria-hidden />
        <span>Se connecter</span>
      </button>
    ) : (
      <NavLink to="/mon-compte/profil" className={className}>
        <FiUser className="kazamansa-icon-accent" aria-hidden />
        <span>Mon compte</span>
      </NavLink>
    );

  const renderFavorisLink = (className: string) =>
    !token ? (
      <button type="button" onClick={openConnexion} className={className}>
        <AiOutlineHeart className="kazamansa-icon-accent" aria-hidden />
        <span>Favoris</span>
      </button>
    ) : (
      <NavLink to="/mon-compte/favoris" className={className}>
        <AiOutlineHeart className="kazamansa-icon-accent" aria-hidden />
        <span>Favoris</span>
      </NavLink>
    );

  return (
    <div>
      <Navbar
        expand="lg"
        className="frontheader-component headering"
        id="navbar"
      >
        <div
          className={`headering-second-level-header kazamansa-second-header ${scrolled ? "scrolled" : ""
            }`}
        >
          <div className="kazamansa-desktop-wrap d-none d-lg-flex flex-column w-100">
            <div className="kazamansa-row-top d-flex align-items-center justify-content-between w-100">
              <Link to="/" className="navbar-brand kazamansa-brand m-0">
                <img
                  src={KAZA_LOGO}
                  alt="Kazamansa — Inspiration et innovation"
                  className="app-logo kazamansa-logo-img"
                />
              </Link>
              <div className="kazamansa-search-cluster">
                <SearchForm />
                <button
                  type="button"
                  className="kazamansa-search-menu-btn"
                  aria-label="Parcourir les catégories"
                  onClick={() => setShowCategoryModal(true)}
                >
                  <TfiMenuAlt />
                </button>
              </div>
              <div className="kazamansa-header-actions d-flex align-items-center flex-shrink-0">
                {renderAccountLink("kazamansa-action-link")}
                <span className="kazamansa-action-divider" aria-hidden />
                {renderFavorisLink("kazamansa-action-link")}
                <span className="kazamansa-action-divider" aria-hidden />
                <NavLink to="/panier" className="kazamansa-action-link">
                  <span className="position-relative d-inline-flex align-items-center">
                    <FiShoppingCart
                      className="kazamansa-icon-accent"
                      aria-hidden
                    />
                    <span className="counter-shop-notif kazamansa-cart-badge">
                      {cartItems?.length ?? 0}
                    </span>
                  </span>
                  <span>Panier</span>
                </NavLink>
              </div>
            </div>
            <nav
              className="kazamansa-row-bottom"
              aria-label="Navigation principale"
            >
              <NavLink
                to="/"
                className={({ isActive }) =>
                  `kazamansa-nav-pill${isActive ? " active" : ""}`
                }
                end
              >
                Accueil
              </NavLink>
              <NavLink
                to="/produits"
                className={({ isActive }) =>
                  `kazamansa-nav-pill${isActive ? " active" : ""}`
                }
              >
                Catégories
              </NavLink>
              <NavLink
                to="/a-propos-de-nous"
                className={({ isActive }) =>
                  `kazamansa-nav-pill${isActive ? " active" : ""}`
                }
              >
                Qui sommes-nous
              </NavLink>
              <NavLink
                to="/contact"
                className={({ isActive }) =>
                  `kazamansa-nav-pill${isActive ? " active" : ""}`
                }
              >
                Contact
              </NavLink>
            </nav>
          </div>

          <div className="d-flex d-lg-none w-100 align-items-center justify-content-between kazamansa-mobile-top">
            <Navbar.Brand as={Link} to="/" className="m-0">
              <img
                src={KAZA_LOGO}
                alt="Kazamansa — Inspiration et innovation"
                className="app-logo kazamansa-logo-img"
              />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
          </div>

          <Navbar.Collapse
            id="basic-navbar-nav"
            className="kazamansa-navbar-collapse w-100"
          >
            <Nav className="navbar navbar-light flex-column w-100 kazamansa-mobile-collapse-nav">
              <div className="kazamansa-mobile-primary-nav d-flex flex-column gap-2 mb-3">
                <NavLink to="/" className="kazamansa-mobile-nav-link" end>
                  Accueil
                </NavLink>
                <NavLink to="/produits" className="kazamansa-mobile-nav-link">
                  Catégories
                </NavLink>
                <NavLink
                  to="/a-propos-de-nous"
                  className="kazamansa-mobile-nav-link"
                >
                  Qui sommes-nous
                </NavLink>
                <NavLink to="/contact" className="kazamansa-mobile-nav-link">
                  Contact
                </NavLink>
              </div>
              <div className="kazamansa-mobile-actions d-flex flex-column gap-2 pb-3">
                {renderAccountLink("kazamansa-action-link kazamansa-action-link--mobile")}
                {renderFavorisLink("kazamansa-action-link kazamansa-action-link--mobile")}
                <NavLink
                  to="/panier"
                  className="kazamansa-action-link kazamansa-action-link--mobile"
                >
                  <span className="position-relative d-inline-flex align-items-center">
                    <FiShoppingCart
                      className="kazamansa-icon-accent"
                      aria-hidden
                    />
                    <span className="counter-shop-notif kazamansa-cart-badge">
                      {cartItems?.length ?? 0}
                    </span>
                  </span>
                  <span>Panier</span>
                </NavLink>
              </div>
            </Nav>
          </Navbar.Collapse>

          <ConnexionModal
            modalConnexion={modalConnexion}
            setModalConnexion={setModalConnexion}
          />
          <MobileCategoryModal
            show={showCategoryModal}
            setShow={setShowCategoryModal}
            value={value}
            setValue={setValue}
            setSearchCategory={setSearchCategory}
            setSearchSousCategory={setSearchSousCategory}
            query={query}
            setQuery={setQuery}
            catgoryId={state?.catgoryId}
          />

          <div className="container-menu-search-bloc-and-cart kazamansa-mobile-bottom-bar no-view-desktop position-relative mt-3">
            <div className="kazamansa-search-cluster kazamansa-search-cluster--mobile flex-grow-1 me-2">
              <SearchForm />
              <button
                type="button"
                className="kazamansa-search-menu-btn"
                aria-label="Parcourir les catégories"
                onClick={() => setShowCategoryModal(true)}
              >
                <TfiMenuAlt />
              </button>
            </div>
            <NavLink
              to="/panier"
              className="btn nav-link menu-link position-relative flex-shrink-0 kazamansa-mobile-cart-btn"
            >
              <FiShoppingCart style={{ fontSize: 18 }} className="kazamansa-icon-accent" />
              <span className="counter-shop-notif">{cartItems?.length}</span>
            </NavLink>
          </div>
        </div>
      </Navbar>
    </div>
  );
};

export default FrontHeader;
